/**
 * Baut einen Link auf /registrieren und reicht UTM-/fbclid-Parameter aus
 * der aktuellen URL durch. Nur echte Werte aus der Adresse, nie erfundene:
 * Wer ohne Werbeparameter auf /kostenlos kommt, registriert sich ohne Herkunft
 * (Auftrag 24.10.2026; vorher setzte die Seite dann `utm_source=meta` und zählte
 * jeden organischen Besuch als Meta-Anzeige). Die Anzeigen tragen ihre UTMs
 * selbst im Link, `utm_campaign` mit „kostenlos“ darin.
 */

const FORWARDED_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "fbclid",
  "gclid",
];

export function buildRegisterHref(
  currentSearch: string = typeof window !== "undefined" ? window.location.search : "",
): string {
  const incoming = new URLSearchParams(currentSearch);
  const out = new URLSearchParams();

  for (const key of FORWARDED_KEYS) {
    const value = incoming.get(key);
    if (value) out.set(key, value);
  }

  const qs = out.toString();
  return qs ? `/registrieren?${qs}` : "/registrieren";
}
